import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { NeonText } from '../effects';
import { ProjectCarousel } from '../common';
import { useLanguage } from '@/i18n';
import { projects } from '../../data';
import styles from './Portfolio.module.css';

export function Portfolio() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });
  const { t } = useLanguage();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  return (
    <section id="portfolio" className={styles.portfolio} ref={ref}>
      <div className={styles.container}>
        <motion.div
          className={styles.header}
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <NeonText as="h2" color="pink" effect="glow" className={styles.title} animate={false}>
            {t.portfolio.title}
          </NeonText>
        </motion.div>

        <motion.div
          className={styles.carouselWrapper}
          initial="hidden"
          animate={isInView ? 'visible' : 'hidden'}
          variants={containerVariants}
        >
          <ProjectCarousel projects={projects} />
        </motion.div>

        <motion.div
          className={styles.viewAll}
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ delay: 0.8 }}
        >
          <Link to="/proyectos" className={styles.viewAllLink}>
            {t.portfolio.viewAll}
            <span className={styles.arrow}>→</span>
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
